<label [attr.for]="name" [ngClass]="labelCssClass" *ngIf="label && name && loaded">{{ label }}</label>
<input
  *ngIf="loaded"
  type="text"
  [ngClass]="cssClass"
  [attr.id]="name"
  [attr.name]="name"
  [name]="name"
  [readOnly]="readonly"
  [attr.aria-required]="required || null"
  [required]="required"
  (countrychange)="i18nizePhoneNumber(true)"
  [formControl]="phoneNumber"
  #intlTelInput
/>
<!-- <wsb-validation-error-msg [fc]="phoneNumber"></wsb-validation-error-msg> -->

<!-- (ngModelChange)="onChange($event)"
  [(ngModel)]="phoneNumber" -->
